/**
 * Configuration for MSAL
 */

import { Configuration, PublicClientApplication } from "@azure/msal-browser";

// Environment variables from .env file
const {
    REACT_APP_MS_CLIENT_ID,
    REACT_APP_MS_TENANT_ID,    
    REACT_APP_MS_REDIRECT_URI,
    REACT_APP_MS_SCOPES
} = process.env;

const clientID = REACT_APP_MS_CLIENT_ID || '';
const tenantID = REACT_APP_MS_TENANT_ID || '';
const redirectURI = REACT_APP_MS_REDIRECT_URI || '';
export const scopesMS = REACT_APP_MS_SCOPES ? REACT_APP_MS_SCOPES.split(',') : [];

/**
 * MSAL Configuration object that will be used to configure the MSAL instance
 */
export const msalConfig: Configuration = {
    auth: {
        clientId: clientID,
        authority: `https://login.microsoftonline.com/${tenantID}`,
        redirectUri: redirectURI 
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: true,         
    }
};

/**
 * MSAL instance
 */
const msalInstance  = new PublicClientApplication(msalConfig);

// Initialize the MSAL instance, this assures that MSAL is correctly set up before rendering the application
msalInstance.initialize();

export { msalInstance }; 